module.exports = __webpack_public_path__ + "img/aav2.48bff92b.png";